import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { withRights } from 'providers/RightsConsumer';
import { DocumentPartnerExtraInformationDataRowComponent } from './DocumentPartnerExtraInformationDataRowComponent';
import CollapseOrBlankCard from 'components/common/CollapseOrBlankCard';
import Description from '@mui/icons-material/Description';
import { Prompt } from 'react-router-dom';

const DocumentPartnerExtraInformationComponent = ({
  data,
  onPropertyChange,
  clientExtraInformationWrite,
  onAddExtraInfo,
  onDeleteRow,
  t,
  rights,
  countryCode,
  onSavePartnerExtraInfos,
  saveDisabled,
  validateExtraInformation,
  savedWithMandatoryPropertiesEmpty,
  partnerId, 
  saving,
  loadPropertyDetails
}) => {
  const [cardExpanded, setCardExpanded] = useState({});
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    setShowPrompt(saveDisabled.some(disabled => !disabled));
  }, [cardExpanded, saveDisabled]);

  const toggleCardExpansion = index => {
    setCardExpanded(prevExpanded => ({
      ...prevExpanded,
      [index]: !prevExpanded[index]
    }));
  };

  return (
    <Grid item xs={12}>
      {showPrompt && <Prompt message={t('LeavingWithoutSaving')} />}
      {data?.sections?.map((section, index) => (
        <CollapseOrBlankCard
          key={index}
          id={`extraInfoCard-${index}`}
          icon={Description}
          title={section.name}
          expanded={cardExpanded[index]}
          onToggle={() => toggleCardExpansion(index)}
          canExpand={partnerId != null}
        >
          <DocumentPartnerExtraInformationDataRowComponent
            t={t}
            section={section}
            sectionIdx={index}
            onDeleteRow={onDeleteRow}
            clientExtraInformationWrite={clientExtraInformationWrite}
            onPropertyChange={onPropertyChange}
            onAddExtraInfo={onAddExtraInfo}
            rights={rights}
            countryCode={countryCode}
            onSavePartnerExtraInfos={onSavePartnerExtraInfos}
            saveDisabled={saveDisabled}
            validateExtraInformation={validateExtraInformation}
            savedWithMandatoryPropertiesEmpty={savedWithMandatoryPropertiesEmpty}
            saving={saving}
            loadPropertyDetails={loadPropertyDetails}
          />
        </CollapseOrBlankCard>
      ))}
    </Grid>
  );
};

DocumentPartnerExtraInformationComponent.propTypes = {
  data: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  clientExtraInformationWrite: PropTypes.bool.isRequired,
  onAddExtraInfo: PropTypes.func.isRequired,
  onDeleteRow: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  countryCode: PropTypes.string,
  onSavePartnerExtraInfos: PropTypes.func.isRequired,
  saveDisabled: PropTypes.array.isRequired,
  validateExtraInformation: PropTypes.func.isRequired,
  savedWithMandatoryPropertiesEmpty: PropTypes.bool.isRequired,
  partnerId: PropTypes.number.isRequired, 
  saving: PropTypes.array.isRequired,
  loadPropertyDetails: PropTypes.func
};

export default withRights(DocumentPartnerExtraInformationComponent);
